import { http } from '../../utils/http'
import conf from '../../config'

export const API_ROOT = `${conf.API_URL}`

const notisphereCommunicationProductService = {
    getFieldDefinitions() {
        return http.get(`${API_ROOT}/notisphere/communications/product-field-definitions`).then(resp => {
            return resp
        })
    }
}

export default notisphereCommunicationProductService